// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { accountMessagesStyles } from "@werner/Overrides/Widgets/MyAccount/AccountMessages";
import { color, mergeWithCss, styledScrollbar } from "@werner/XDL/Utilities";
import { css } from "styled-components";

accountMessagesStyles.messagesAccordion = {
    mergeCss: true,
    css: css`
        width: 100%;
        height: 100%;
        border: 1px solid ${color("common.border", 0.5)};
    `,
};

accountMessagesStyles.messagesAccordionSection = {
    mergeCss: true,
    panelProps: {
        css: css`
            height: 100%;
            max-height: 500px;
            overflow-y: auto;
            padding: 0;
            ${styledScrollbar()};
            margin-bottom: 6px;
            padding-top: 18px;
            overflow-x: hidden;
        `,
    },
    headerProps: {
        css: css`
            padding: 10px 15px;
            border-bottom: 1px solid ${color("common.border", 0.5)};
            position: relative;
            z-index: 1;
            &&&& button {
                padding: 0;
                border: none;
            }
            ${TypographyStyle} {
                font-size: 14px;
                font-weight: 400;
                line-height: 18px;
            }
        `,
    },
};

accountMessagesStyles.messageCardGridItem = {
    width: 12,
    css: css`
        &:hover {
            background: ${color("common.ui8")};
            cursor: pointer;
        }
        border-bottom: 1px solid ${color("common.border", 0.5)};
    `,
};

accountMessagesStyles.messageCard = {
    ...mergeWithCss(accountMessagesStyles.messageCard, {
        dateTimeText: { color: "common.border", size: 12, weight: 400 },
        subjectText: {
            css: css`
                &&&& {
                    color: ${color("text.main")};
                    font-size: 16px;
                    font-weight: 500;
                    &:hover {
                        cursor: pointer;
                    }
                }
            `,
        },
        bodyGridItem: {
            width: 12,
            css: css`
                &&&& {
                    margin-top: 16px;
                    &:hover {
                        cursor: pointer;
                    }
                }
            `,
        },
        bodyText: {
            size: 15,
            lineHeight: "22px",
            weight: 400,
        },
        actionButton: {
            variant: "secondary",
            typographyProps: {
                size: 12,
                weight: 400,
            },
            css: css`
                min-height: auto;
                justify-content: flex-end;
                position: absolute;
                top: 8px;
                right: 15px;
                padding: 0;
                border: none;
                ${TypographyStyle} {
                    color: ${color("common.ui1")};
                }

                &:hover {
                    ${TypographyStyle} {
                        color: ${color("common.ui3")};
                    }
                }

                &:focus {
                    box-shadow: none;
                }
            `,
        },
        article: {
            css: css`
                padding: 10px 15px;
                position: relative;
            `,
        },
        bottomBorderGridItem: { width: 0 },
    }),
};

accountMessagesStyles.messageFilter = {
    radioGroup: {
        sizeVariant: "small",
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 15px;
        `,
    },
    radioButton: {
        css: css`
            margin: 10px 20px 5px 0;
        `,
    },
};

accountMessagesStyles.accordionTitleWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 16px;
    `,
};

accountMessagesStyles.accordionTitleText = {
    css: css`
        white-space: nowrap;
        display: inline-flex;
        width: 150px;
    `,
};

accountMessagesStyles.noMessagesText = {
    ...mergeWithCss(accountMessagesStyles.noMessagesText, {
        css: css`
            margin-top: 20px;
        `,
    }),
};
